import { render, staticRenderFns } from "./PartnerTour.vue?vue&type=template&id=e9126c34&"
import script from "./PartnerTour.vue?vue&type=script&lang=js&"
export * from "./PartnerTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports